import { render } from "./kline.vue?vue&type=template&id=40efc22e&scoped=true&ts=true"
import script from "./kline.vue?vue&type=script&lang=ts"
export * from "./kline.vue?vue&type=script&lang=ts"

import "./kline.vue?vue&type=style&index=0&id=40efc22e&lang=less"
import "./kline.vue?vue&type=style&index=1&id=40efc22e&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40efc22e"]])

export default __exports__